import React, { Component } from "react";
import {
  Wrapper,
  WebContainer,
  Card,
  PrimaryButton,
  SecondaryButton,
  CardBody,
  Title,
  Copy,
  Spin
} from "app/NativeComponents/common";

import { checkIfUserHasBillingAddon, renderPrice } from "app/NativeActions";

import CampaignList from "./CampaignList";

class Body extends Component {
  constructor(props) {
    super(props);
    this.state = {
      monthly_price: null
    };
  }

  componentDidMount() {
    for (var i = 0; i < this.props.billing_addons.length; i++) {
      if (this.props.billing_addons[i].slug == "campaigns") {
        this.setState({
          monthly_price: this.props.billing_addons[i].monthly_price
        });
      }
    }
  }

  onPurchaseItem() {
    if (
      this.props.card_info.has_card &&
      this.props.billing_addons.length > 0 &&
      (this.props.user.team_clearance_level > 0 ||
        this.props.user.team_owner == 1)
    ) {
      this.props.setModal({
        title: "Purchase add-on",
        description:
          "Are you sure you want to purchase this add-on? You will receive a pro-rated charge today. On your next billing cycle you will be charged " +
          renderPrice(this.state.monthly_price) +
          ".",
        icon: "check",
        submit: "Confirm Purchase",
        onPress: () => {
          this.props.updateBillingAddon({
            token: this.props.token,
            type: "purchase",
            slug: "campaigns",
            addon_id: "1"
          });
        },
        cancel: "Not right now",
        onCancel: () => {}
      });
      this.props.toggleModal({ show: true, type: "normal" });
    } else {
      this.props.appRedirect({ redirect: "cardOnFile" });
    }
  }

  render() {
    if (
      checkIfUserHasBillingAddon({
        billing_addons: this.props.billing_addons,
        slug: "campaigns"
      })
    ) {
      if (this.props.campaigns.length > 0) {
        return <CampaignList {...this.props} />;
      } else if (this.props.refreshing) {
        return (
          <Wrapper style={{ flex: 1 }}>
            <Wrapper
              style={{
                alignItems: "center",
                justifyContent: "flex-start",
                alignSelf: "stretch",
                flex: 1
              }}
            >
              <CardBody>
                <Spin />
              </CardBody>
            </Wrapper>
          </Wrapper>
        );
      }

      return (
        <Wrapper style={{ flex: 1 }}>
          <WebContainer>
            <CardBody style={{ marginTop: 20 }}>
              <Title style={{ textAlign: "center" }}>
                Your campaigns will show here.
              </Title>
              <Copy style={{ textAlign: "center" }}>
                Stand out by optimizing sequential messages to your leads. Build
                campaigns using multiple mail templates that are sent in order
                exactly when you want them.{" "}
              </Copy>
            </CardBody>
            <Card>
              <PrimaryButton
                onPress={() => {
                  //Add to subscription
                  this.props.newCampaign();
                }}
              >
                Create New Campaign
              </PrimaryButton>
            </Card>
          </WebContainer>
        </Wrapper>
      );
    } else {
      if (this.props.platform != "ios") {
        return (
          <Wrapper style={{ flex: 1 }}>
            <WebContainer>
              <CardBody style={{ marginTop: 20 }}>
                <Title style={{ textAlign: "center" }}>
                  You need the "Campaigns" product.
                </Title>
                <Copy style={{ textAlign: "center" }}>
                  You need the "Campaigns" product to use this feature. Stand
                  out by optimizing sequential messages to your leads.
                </Copy>
              </CardBody>
              <Card>
                <PrimaryButton
                  onPress={() => {
                    //set campaign blank
                    this.onPurchaseItem();
                  }}
                >
                  Add To Subscription
                </PrimaryButton>
              </Card>
            </WebContainer>
          </Wrapper>
        );
      } else {
        return (
          <Wrapper style={{ flex: 1 }}>
            <WebContainer>
              <CardBody style={{ marginTop: 20 }}>
                <Title style={{ textAlign: "center" }}>
                  You need the "Campaigns" product.
                </Title>
                <Copy style={{ textAlign: "center" }}>
                  You need the "Campaigns" product to use this feature. Please
                  go to DealMachine on the web to manage your account.
                </Copy>
              </CardBody>
            </WebContainer>
          </Wrapper>
        );
      }
    }

    return (
      <Wrapper style={{ flex: 1 }}>
        <WebContainer>
          <CardBody style={{ marginTop: 20 }}>
            <Title style={{ textAlign: "center" }}>
              Your campaigns will show here.
            </Title>
            <Copy style={{ textAlign: "center" }}>
              Stand out by optimizing sequential messages to your leads. Build
              campaigns using multiple mail templates that are sent in order
              exactly when you want them.{" "}
            </Copy>
          </CardBody>
          <Card style={{ borderRadius: 30, overflow: "hidden" }}>
            <PrimaryButton
              onPress={() => {
                //set campaign blank
                this.props.newCampaign();
              }}
            >
              Create New Campaign
            </PrimaryButton>
          </Card>
        </WebContainer>
      </Wrapper>
    );
  }
}

export default Body;
